export const CURRENT_LOCATION_LABEL = 'Use Current Location';

/** Shown when the delivery address is outside configured zones (store selector). */
export const OUT_OF_DELIVERY_ZONE_MESSAGE =
  "We don't deliver to this address. Please try a different address to continue";
